import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';

export class GiftCardEmailTemplateDto extends BaseDto {
  receiptTemplateId?: number;
  templateName?: string;
  emailTemplateTypeId?: number;
  merchant?: MerchantDto;
  templateHtml?: string;
}
